import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    let displayValue = value;

    if (value === "OutOfStock") {
        displayValue = "Out Of Stock";
    }
    if (value === "InStock") {
        displayValue = "In Stock";
    }
    return (
        <label className={`ns-checkbox ns-d-inline-block ${className}`}>
            {displayValue}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark ns-absolute">
                <svg class="ns-svg" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.771 40.395l33.749-33.749 4.48 4.48-38.229 38.229-17.771-17.771 4.48-4.48z"></path>
                </svg>
            </span>
        </label>
    )
}